export default {
  payment_sent: 'Payment successfully sent'
}



// WEBPACK FOOTER //
// ./src/js/i18n/to_replace/transactions.js